import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Chip } from '@material-ui/core';

import { CardLayout } from 'shared/components/layouts';
import { UserNameLink } from 'shared/components/symbols';

// Container

interface ContainerProps {
  withDivider?: boolean;
}

export const Container = styled(CardLayout)<ContainerProps>`
  display: flex;
  flex-direction: row;
  padding: 1rem;
  overflow-x: hidden;
  user-select: none;
  gap: 0.5rem;

  ${p =>
    p.withDivider &&
    css`
      --card-layout-border-radius: 0;
      --card-layout-shadow: none;

      &:not(:last-child) {
        border-bottom: 1px solid ${p.theme.palette.divider};
      }
    `}
`;

// Content

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  gap: 0.25rem;
  flex: 1;

  ${p => p.theme.breakpoints.up('md')} {
    justify-content: center;
  }
`;

// Header

export const Header = styled.header`
  display: flex;
  gap: 0.5rem;
  overflow-x: hidden;

  ${p => p.theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: flex-start;
  }

  ${p => p.theme.breakpoints.up('md')} {
    flex-direction: row;
    align-items: center;
  }
`;

// Title

export const Title = styled(UserNameLink)`
  max-width: 100%;
  font-weight: bold;
  color: ${p => p.theme.palette.primary.dark};
  line-height: normal;
  cursor: pointer;
`;

// Affiliation

export const Affiliation = styled(Chip)`
  text-transform: capitalize;
`;

Affiliation.defaultProps = {
  color: 'secondary',
  size: 'small',
};

// Description

export const Description = styled.span`
  display: block;
`;

// Buttons

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
